import { GetIndexInArray } from "./components/Centerpanel/Centerpanel.tsx";

import {
  BackgroundSound,
  FocusedSound,
  POI,
  POITranslation,
  PendingUploadCommit,
  Point,
  RouteState,
} from "./api/edits/editRoute.responses.ts";
import { Language } from "./api/lanugages/language.responses.ts";
import { Falloff } from "./api/falloffs/falloffs.responses.ts";
import { Route } from "react-router-dom";
export type ToolType = "select" | "move" | "draw" | "delete" | "start" | "stop";

// An enum with all the types of actions to use in our reducer
export enum RouteActionKind {
  LOAD_ROUTE = "LOAD_ROUTE",
  ADD_LANGUAGE = "ADD_LANGUAGE",

  // Adding points
  ADD_POI = "ADD_POI",
  ADD_FOCUSED = "ADD_FOCUSED",
  ADD_BACKGROUND = "ADD_BACKGROUND",
  ADD_ROUTELINE = "ADD_ROUTELINE",
  ADD_ROUTELINEPOINT = "ADD_ROUTELINEPOINT",
  APPEND_ROUTELINEPOINT = "APPEND_ROUTELINEPOINT",

  // MOVEing points
  MOVE_POI = "MOVE_POI",
  MOVE_FOCUSED = "MOVE_FOCUSED",
  MOVE_BACKGROUND = "MOVE_BACKGROUND",
  MOVE_ROUTELINE = "MOVE_ROUTELINE",
  MOVE_ROUTELINEPOINT = "MOVE_ROUTELINEPOINT",

  // Deleting points
  DELETE_POI = "DELETE_POI",
  DELETE_FOCUSED = "DELETE_FOCUSED",
  DELETE_BACKGROUND = "DELETE_BACKGROUND",
  DELETE_ROUTELINE = "DELETE_ROUTELINE",
  DELETE_ROUTELINEPOINT = "DELETE_ROUTELINEPOINT",

  // Change focused properties
  CHANGE_FOCUSED_NAME = "CHANGE_FOCUSED_NAME",
  CHANGE_FOCUSED_LATITUDE = "CHANGE_FOCUSED_LATITUDE",
  CHANGE_FOCUSED_LONGITUDE = "CHANGE_FOCUSED_LONGITUDE",
  CHANGE_FOCUSED_AUDIO_PATH = "CHANGE_FOCUSED_AUDIO_PATH",
  CHANGE_FOCUSED_RADIUS = "CHANGE_FOCUSED_RADIUS",
  CHANGE_FOCUSED_MIN_VOLUME = "CHANGE_FOCUSED_MIN_VOLUME",
  CHANGE_FOCUSED_MAX_VOLUME = "CHANGE_FOCUSED_MAX_VOLUME",
  CHANGE_FOCUSED_FALLOFF_ID = "CHANGE_FOCUSED_FALLOFF_ID",
  CHANGE_FOCUSED_FALLOF_NAME = "CHANGE_FOCUSED_FALLOF_NAME",

  // Change background properties
  CHANGE_BACKGROUND_NAME = "CHANGE_BACKGROUND_NAME",
  CHANGE_BACKGROUND_LATITUDE = "CHANGE_BACKGROUND_LATITUDE",
  CHANGE_BACKGROUND_LONGITUDE = "CHANGE_BACKGROUND_LONGITUDE",
  CHANGE_BACKGROUND_AUDIO_PATH = "CHANGE_BACKGROUND_AUDIO_PATH",
  CHANGE_BACKGROUND_RADIUS = "CHANGE_BACKGROUND_RADIUS",
  CHANGE_BACKGROUND_MIN_VOLUME = "CHANGE_BACKGROUND_MIN_VOLUME",
  CHANGE_BACKGROUND_MAX_VOLUME = "CHANGE_BACKGROUND_MAX_VOLUME",

  // Change POI properties
  CHANGE_POI_NAME = "CHANGE_POI_NAME",
  CHANGE_POI_LATITUDE = "CHANGE_POI_LATITUDE",
  CHANGE_POI_LONGITUDE = "CHANGE_POI_LONGITUDE",
  CHANGE_POI_POINT_ORDER = "CHANGE_POI_POINT_ORDER",
  CHANGE_POI_RADIUS = "CHANGE_POI_RADIUS",
  CHANGE_POI_AUDIO_PATH = "CHANGE_POI_AUDIO_PATH",
  CHANGE_POI_IMAGE_PATH = "CHANGE_POI_IMAGE_PATH",
  CHANGE_POI_TEXT = "CHANGE_POI_TEXT",

  // Changing route properties
  CHANGE_ROUTE_APPLE_ID = "CHANGE_ROUTE_APPLE_ID",
  CHANGE_ROUTE_PLAY_ID = "CHANGE_ROUTE_PLAY_ID",
  CHANGE_ROUTE_TIME_DURATION = "CHANGE_ROUTE_APPLEID",
  CHANGE_ROUTE_DISTANCE = "CHANGE_ROUTE_DISTNCE",
  CHANGE_ROUTE_PRICE = "CHANGE_ROUTE_PRICE",
  CHANGE_ROUTE_PREVIEW_IMAGE_PATH = "CHANGE_ROUTE_PREVIEW_IMAGE_PATH",
  CHANGE_ROUTE_NAME = "CHANGE_ROUTE_NAME",
  CHANGE_ROUTE_DESCRIPTION = "CHANGE_ROUTE_DESCRIPTION",

  //Adding falloffs available in db
  LOAD_FALLOFFS = "LOAD_FALLOFFS",

  // Upload queue management
  ADD_PENDING_UPLOAD = "ADD_PENDING_UPLOAD",
}
export type plIdNumber = {
  id: number;
  num: number;
};
export type plIdString = {
  id: number;
  str: string;
};
export type plNumber = {
  num: number;
};
export type plString = {
  str: string;
};
export type plPoint = {
  pnt: Point;
};
export type plId = {
  id: number;
};
export type plIdPoint = {
  id: number;
  pnt: Point;
};
export type plPointInsert = {
  pnt: Point;
  insertIndex: number;
};

export type changePOIString = {
  id: number;
  newValue: string;
  language: string;
};

export type changeRouteString = {
  newValue: string;
  language: string;
};
// A type for our actions, and different ones for different payloads
export type RouteAction =
  | { type: RouteActionKind.LOAD_ROUTE; payload: RouteState }
  | {
      type:
        | RouteActionKind.ADD_POI
        | RouteActionKind.ADD_BACKGROUND
        | RouteActionKind.ADD_FOCUSED
        | RouteActionKind.ADD_ROUTELINE
        | RouteActionKind.APPEND_ROUTELINEPOINT
        | RouteActionKind.MOVE_ROUTELINE;
      payload: plPoint;
    }
  | {
      type: RouteActionKind.ADD_ROUTELINEPOINT;
      payload: plPointInsert;
    }
  | {
      type:
        | RouteActionKind.MOVE_ROUTELINEPOINT
        | RouteActionKind.MOVE_POI
        | RouteActionKind.MOVE_BACKGROUND
        | RouteActionKind.MOVE_FOCUSED;
      payload: plIdPoint;
    }
  | {
      type:
        | RouteActionKind.CHANGE_FOCUSED_LATITUDE
        | RouteActionKind.CHANGE_FOCUSED_LONGITUDE
        | RouteActionKind.CHANGE_FOCUSED_RADIUS
        | RouteActionKind.CHANGE_FOCUSED_MIN_VOLUME
        | RouteActionKind.CHANGE_FOCUSED_MAX_VOLUME
        | RouteActionKind.CHANGE_FOCUSED_FALLOFF_ID
        | RouteActionKind.CHANGE_BACKGROUND_LATITUDE
        | RouteActionKind.CHANGE_BACKGROUND_LONGITUDE
        | RouteActionKind.CHANGE_BACKGROUND_RADIUS
        | RouteActionKind.CHANGE_BACKGROUND_MIN_VOLUME
        | RouteActionKind.CHANGE_BACKGROUND_MAX_VOLUME
        | RouteActionKind.CHANGE_POI_LATITUDE
        | RouteActionKind.CHANGE_POI_LONGITUDE
        | RouteActionKind.CHANGE_POI_POINT_ORDER
        | RouteActionKind.CHANGE_POI_RADIUS;
      payload: plIdNumber;
    }
  | {
      type:
        | RouteActionKind.CHANGE_FOCUSED_NAME
        | RouteActionKind.CHANGE_FOCUSED_AUDIO_PATH
        | RouteActionKind.CHANGE_FOCUSED_FALLOF_NAME
        | RouteActionKind.CHANGE_BACKGROUND_NAME
        | RouteActionKind.CHANGE_BACKGROUND_AUDIO_PATH
        | RouteActionKind.CHANGE_POI_IMAGE_PATH;
      payload: plIdString;
    }
  | {
      type:
        | RouteActionKind.DELETE_POI
        | RouteActionKind.DELETE_BACKGROUND
        | RouteActionKind.DELETE_FOCUSED
        | RouteActionKind.DELETE_ROUTELINE
        | RouteActionKind.DELETE_ROUTELINEPOINT;
      payload: plId;
    }
  | { type: RouteActionKind.ADD_LANGUAGE; payload: Language & { initialName: string; initialDescription: string } }
  | {
      type:
        | RouteActionKind.CHANGE_ROUTE_APPLE_ID
        | RouteActionKind.CHANGE_ROUTE_PLAY_ID
        | RouteActionKind.CHANGE_ROUTE_TIME_DURATION
        | RouteActionKind.CHANGE_ROUTE_DISTANCE
        | RouteActionKind.CHANGE_ROUTE_PREVIEW_IMAGE_PATH
        | RouteActionKind.CHANGE_ROUTE_PRICE;
      payload: plString;
    }
  | {
      type: RouteActionKind.CHANGE_POI_TEXT | RouteActionKind.CHANGE_POI_NAME | RouteActionKind.CHANGE_POI_AUDIO_PATH;

      payload: changePOIString;
    }
  | {
      type:
        | RouteActionKind.CHANGE_ROUTE_NAME
        | RouteActionKind.CHANGE_ROUTE_DESCRIPTION;

      payload: changeRouteString;
    }
  | {
      type: RouteActionKind.LOAD_FALLOFFS;
      payload: Falloff[];
    }
  | {
      type: RouteActionKind.ADD_PENDING_UPLOAD;
      payload: PendingUploadCommit;
    };
// An interface for our state

export const initialRouteState: RouteState = {
  id: "",
  appleStoreId: "",
  playStoreId: "",
  timeDuration: "",
  distanceInMeters: 0,
  priceInEuros: "0.0",
  previewImagePath: "",
  city: {
    id: 0,
    name: "",
    countryId: 0,
  },
  sponsor: {
    id: 0,
    name: "",
    imagePath: "",
  },
  routeTranslations: {
    en: {
      id: 0,
      name: "name",
      description: "",
      languageName: "English",
    },
  },
  linePoints: [],
  backgroundSounds: [],
  focusedSounds: [],
  pointsOfInterest: [],
  falloffs: [],
  pendingUploadCommits: [],
};

// Our reducer function that uses a switch statement to handle our actions
export function routeReducer(state: RouteState, action: RouteAction) {
  const { type, payload } = action;
  switch (type) {
    case RouteActionKind.LOAD_ROUTE:
      return {
        ...state,
        ...payload,
      };
    case RouteActionKind.CHANGE_POI_NAME: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].pointOfInterestTranslations[payload.language].name =
        payload.newValue;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_POI_LATITUDE: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].latitude = payload.num;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_POI_LONGITUDE: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].longitude = payload.num;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_POI_POINT_ORDER: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].pointOrder = payload.num;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_POI_RADIUS: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].radius = payload.num;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_POI_AUDIO_PATH: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].pointOfInterestTranslations[payload.language].audioPath = payload.newValue;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_POI_IMAGE_PATH: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].imagePath = payload.str;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_POI_TEXT: {
      let tempPOIs: POI[] = state.pointsOfInterest;
      tempPOIs[payload.id].pointOfInterestTranslations[payload.language].text =
        payload.newValue;
      return {
        ...state,
        pointsOfInterest: tempPOIs,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_NAME: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[payload.id].name = payload.str;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_LATITUDE: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[payload.id].latitude = payload.num;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_LONGITUDE: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[payload.id].longitude = payload.num;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_AUDIO_PATH: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[payload.id].audioPath = payload.str;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_RADIUS: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[payload.id].radius = payload.num;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_MIN_VOLUME: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[payload.id].minVolume = payload.num;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_MAX_VOLUME: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[payload.id].maxVolume = payload.num;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_FOCUSED_FALLOFF_ID: {
      // let tempFss: FocusedSound[] = state.focusedSounds;
      // tempFss[payload.id].falloffId = payload.num;
      // return {
      //   ...state,
      //   focusedSounds: tempFss,
      // };
      return { ...state };
    }
    case RouteActionKind.CHANGE_FOCUSED_FALLOF_NAME: {
      let tempFss: FocusedSound[] = state.focusedSounds;
      const { id, str } = payload;
      const falloff = state.falloffs.find((f) => f.name === str);

      if (falloff) {
        tempFss[id].falloffName = falloff.name;
        tempFss[id].falloffId = falloff.id;
        return {
          ...state,
          focusedSounds: tempFss,
        };
      } else {
        // Show available falloff names in the console (or handle as needed)
        const available = state.falloffs.map((f) => f.name).join(", ");
        // You can't show a UI alert from a reducer, but you can log:
        console.error(
          `Falloff "${str}" does not exist. Available falloffs: ${available}`
        );
        alert(
          `Falloff "${str}" does not exist. Available falloffs: ${available}`
        );
        // Optionally, you could add an error field to your state and handle it in the UI
        return state;
      }
    }
    case RouteActionKind.CHANGE_BACKGROUND_NAME: {
      let tempFss: BackgroundSound[] = state.backgroundSounds;
      tempFss[payload.id].name = payload.str;
      return {
        ...state,
        backgroundSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_BACKGROUND_LATITUDE: {
      let tempFss: BackgroundSound[] = state.backgroundSounds;
      tempFss[payload.id].latitude = payload.num;
      return {
        ...state,
        backgroundSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_BACKGROUND_LONGITUDE: {
      let tempFss: BackgroundSound[] = state.backgroundSounds;
      tempFss[payload.id].longitude = payload.num;
      return {
        ...state,
        backgroundSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_BACKGROUND_AUDIO_PATH: {
      let tempFss: BackgroundSound[] = state.backgroundSounds;
      tempFss[payload.id].audioPath = payload.str;
      return {
        ...state,
        backgroundSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_BACKGROUND_RADIUS: {
      let tempFss: BackgroundSound[] = state.backgroundSounds;
      tempFss[payload.id].radius = payload.num;
      return {
        ...state,
        backgroundSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_BACKGROUND_MIN_VOLUME: {
      let tempFss: BackgroundSound[] = state.backgroundSounds;
      tempFss[payload.id].minVolume = payload.num;
      return {
        ...state,
        backgroundSounds: tempFss,
      };
    }
    case RouteActionKind.CHANGE_BACKGROUND_MAX_VOLUME: {
      let tempFss: BackgroundSound[] = state.backgroundSounds;
      tempFss[payload.id].maxVolume = payload.num;
      return {
        ...state,
        backgroundSounds: tempFss,
      };
    }
    case RouteActionKind.DELETE_FOCUSED: {
      const tempId: number = payload.id;

      let no: number = GetIndexInArray(tempId, state.focusedSounds);
      let tempFss: FocusedSound[] = state.focusedSounds;
      if (no !== -1) {
        tempFss.splice(no, 1);
      }
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.DELETE_BACKGROUND: {
      const tempId: number = payload.id;
      console.log("deleteabck:", payload.id);
      let no: number = GetIndexInArray(tempId, state.backgroundSounds);
      let tempBss: BackgroundSound[] = state.backgroundSounds;
      if (no !== -1) {
        tempBss.splice(no, 1);
      }
      return {
        ...state,
        backgroundSounds: tempBss,
      };
    }
    case RouteActionKind.DELETE_POI: {
      const tempId: number = payload.id;

      let deleteIndex: number = GetIndexInArray(tempId, state.pointsOfInterest);

      // If the POI isn't found, return the current state
      if (deleteIndex === -1) {
        return state;
      }

      let updatedPOIs: POI[] = state.pointsOfInterest;
      updatedPOIs.splice(deleteIndex, 1);
      // Reassign pointOrder values to maintain sequential order
      updatedPOIs = updatedPOIs.map((poi, index) => ({
        ...poi,
        pointOrder: index + 1, // Ensure pointOrder is sequential (1-based index)
      }));

      return {
        ...state,
        pointsOfInterest: updatedPOIs,
      };
    }
    case RouteActionKind.DELETE_ROUTELINEPOINT: {
      const tempId: number = payload.id;
      const copy = [...state.linePoints];
      copy.splice(tempId, 1);
      return {
        ...state,
        linePoints: copy,
      };
    }
    case RouteActionKind.DELETE_ROUTELINE: {
      return {
        ...state,
        linePoints: [],
      };
    }
    case RouteActionKind.ADD_BACKGROUND: {
      const pnt: Point = payload.pnt;
      const rndId = 1000 + Math.floor(Math.random() * 10000);
      let newBackgroudSound: BackgroundSound = {
        id: rndId,
        audioPath: "ambient-sounds/",
        maxVolume: 10,
        minVolume: 1,
        name: String(rndId),
        radius: 50,
        ...pnt,
      };
      return {
        ...state,
        backgroundSounds: [...state.backgroundSounds, newBackgroudSound],
      };
    }
    case RouteActionKind.ADD_FOCUSED: {
      const pnt: Point = payload.pnt;
      const rndId = 1000 + Math.floor(Math.random() * 10000);
      const linearFalloff = state.falloffs.find((f) => f.name === "Linear");
      let newFocusedSound: FocusedSound = {
        id: rndId,
        audioPath: "ambient-sounds/",
        name: String(rndId),
        radius: 50,
        minVolume: 1,
        maxVolume: 10,
        falloffName: linearFalloff?.name ?? "Linear",
        falloffId: linearFalloff?.id ?? 0,
        ...pnt,
      };
      return {
        ...state,
        focusedSounds: [...state.focusedSounds, newFocusedSound],
      };
    }
    case RouteActionKind.ADD_POI: {
      const pnt: Point = payload.pnt;
      const rndId = 1000 + Math.floor(Math.random() * 10000);

      let newPOI: POI = {
        id: rndId,
        pointOrder: state.pointsOfInterest.length + 1,
        radius: 50,
        imagePath: "",
        pointOfInterestTranslations: {},
        ...pnt,
      };
      //used to create the languages that already exist for the route
      for (const [key] of Object.entries(state.routeTranslations)) {
        let newPOITranslation: POITranslation = {
          id: 0,
          name: "Name",
          text: "Text",
        };
        Object.assign(newPOI.pointOfInterestTranslations, {
          [key]: newPOITranslation,
        });
      }

      console.log(JSON.stringify(newPOI, null, 2));
      return {
        ...state,
        pointsOfInterest: [...state.pointsOfInterest, newPOI],
      };
    }
    case RouteActionKind.ADD_ROUTELINEPOINT: {
      const { pnt, insertIndex } = payload;
      const copy = [...state.linePoints];
      copy.splice(insertIndex, 0, pnt);
      return {
        ...state,
        linePoints: copy,
      };
    }
    case RouteActionKind.APPEND_ROUTELINEPOINT: {
      const pnt: Point = payload.pnt;
      return {
        ...state,
        linePoints: [...state.linePoints, pnt],
      };
    }
    case RouteActionKind.ADD_ROUTELINE: {
      const pnt: Point = payload.pnt;
      return {
        ...state,
        linePoints: [{ longitude: pnt.longitude, latitude: pnt.latitude }],
      };
    }
    case RouteActionKind.ADD_LANGUAGE: {
      let newRouteTranslation = {
        [payload.code]: {
          id: 0,
          name: payload.initialName,
          description: payload.initialDescription,
          languageName: payload.name,
        },
      };
      let newRouteTranslations = Object.assign(
        state.routeTranslations,
        newRouteTranslation
      );

      let newPOIs: POI[] = [];
      state.pointsOfInterest.forEach((point) => {
        let newPointTranslation = {
          [payload.code]: {
            id: 0,
            name: "Enter name",
            text: "Enter text",
          },
        };
        let newPointTranslations = Object.assign(
          point.pointOfInterestTranslations,
          newPointTranslation
        );
        let newPoint: POI = {
          ...point,
          pointOfInterestTranslations: newPointTranslations,
        };
        newPOIs.push(newPoint);
      });

      return {
        ...state,
        routeTranslations: newRouteTranslations,
        pointsOfInterest: newPOIs,
      };
    }
    case RouteActionKind.MOVE_BACKGROUND: {
      const pnt: Point = payload.pnt;
      const tempId: number = payload.id;
      let no: number = GetIndexInArray(tempId, state.backgroundSounds);
      let tempBss: BackgroundSound[] = state.backgroundSounds;
      tempBss[no].latitude = pnt.latitude;
      tempBss[no].longitude = pnt.longitude;
      return {
        ...state,
        backgroundSounds: tempBss,
      };
    }
    case RouteActionKind.MOVE_FOCUSED: {
      const pnt: Point = payload.pnt;
      const tempId: number = payload.id;
      let no: number = GetIndexInArray(tempId, state.focusedSounds);
      let tempFss: FocusedSound[] = state.focusedSounds;
      tempFss[no].latitude = pnt.latitude;
      tempFss[no].longitude = pnt.longitude;
      return {
        ...state,
        focusedSounds: tempFss,
      };
    }
    case RouteActionKind.MOVE_POI: {
      const pnt: Point = payload.pnt;
      const tempId: number = payload.id;
      let no: number = GetIndexInArray(tempId, state.pointsOfInterest);
      let tempPOI: POI[] = state.pointsOfInterest;
      tempPOI[no].latitude = pnt.latitude;
      tempPOI[no].longitude = pnt.longitude;
      return {
        ...state,
        pointsOfInterest: tempPOI,
      };
    }
    case RouteActionKind.MOVE_ROUTELINEPOINT: {
      const pnt: Point = payload.pnt;
      const tempId: number = payload.id;
      const copy = state.linePoints.map((p, i) =>
        i === tempId ? { latitude: pnt.latitude, longitude: pnt.longitude } : p
      );
      return {
        ...state,
        linePoints: copy,
      };
    }
    case RouteActionKind.MOVE_ROUTELINE: {
      const pnt: Point = payload.pnt;
      const copy = state.linePoints.map((p) => ({
        latitude: p.latitude + pnt.latitude,
        longitude: p.longitude + pnt.longitude,
      }));
      return {
        ...state,
        linePoints: copy,
      };
    }
    case RouteActionKind.CHANGE_ROUTE_APPLE_ID: {
      return {
        ...state,
        appleStoreId: payload.str,
      };
    }
    case RouteActionKind.CHANGE_ROUTE_PLAY_ID: {
      return {
        ...state,
        playStoreId: payload.str,
      };
    }
    case RouteActionKind.CHANGE_ROUTE_DISTANCE: {
      return {
        ...state,
        distanceInMeters: Number(payload.str),
      };
    }
    case RouteActionKind.CHANGE_ROUTE_PREVIEW_IMAGE_PATH: {
      return {
        ...state,
        previewImagePath: payload.str,
      };
    }
    case RouteActionKind.CHANGE_ROUTE_PRICE: {
      return {
        ...state,
        priceInEuros: payload.str,
      };
    }
    case RouteActionKind.CHANGE_ROUTE_TIME_DURATION: {
      return {
        ...state,
        timeDuration: payload.str,
      };
    }
    case RouteActionKind.CHANGE_ROUTE_NAME: {
      let newRouteTranslations = state.routeTranslations;

      newRouteTranslations[payload.language].name = payload.newValue;
      return {
        ...state,
        routeTranslations: newRouteTranslations,
      };
    }
    case RouteActionKind.CHANGE_ROUTE_DESCRIPTION: {
      let newRouteTranslations = state.routeTranslations;

      newRouteTranslations[payload.language].description = payload.newValue;
      return {
        ...state,
        routeTranslations: newRouteTranslations,
      };
    }
    case RouteActionKind.LOAD_FALLOFFS: {
      return {
        ...state,
        falloffs: payload,
      };
    }
    case RouteActionKind.ADD_PENDING_UPLOAD: {
      return {
        ...state,
        pendingUploadCommits: [...state.pendingUploadCommits, payload],
      };
    }
    default:
      return state;
  }
}
